<app-ebus-session *ngIf="ready"
                  [url]="sessionUrl"
                  theme="epak"></app-ebus-session>
